import { AxiosResponse, isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

export interface EImportFormState {
  dias: number;
  entregaDirecta: boolean;
  esIMDG: boolean;
  esOOG: boolean;
  esReeferOperativo: boolean;
  tamano: number;
}

export const generateImport = async (
  cfe: EImportFormState
): Promise<AxiosResponse> => {
  try {
    const res = await apiClient.post<AxiosResponse>(Endpoints.SimuladorImport, {
      ...cfe,
    });
    return res;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error?.response?.data[0].errorMessage);
    }
    throw error;
  }
};
